import React, { useEffect, useState } from "react";
import ic_cubix_ribbon_logo from "../img/ic_cubix_ribbon_label.png";
import ic_blue_cube from "../img/ic_blue_cube.png";
import "../css/LoginPage.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LoadingUI from "./LoadingUI";

function LoginPage(){

    const navigate = useNavigate();
    const [loadingScreenState,setLoadingScreenState] = useState(false);
 
    const [showLoadingUIState, setShowLoadingUIState] = useState(false);

    const initialLoginField = {
        username:"",
        password:""
    }
    const initialInputErrorState = "";

    const [inputFieldState , setInputFieldState] = useState(initialLoginField);

    const [inputErrorState , setInputErrorState] = useState(initialInputErrorState);

    const clickedOnLogin =()=>{
            console.log("inputFieldState is ", inputFieldState);

            if(inputFieldState.username.length > 0 && inputFieldState.password.length > 0){
                callLoginAPI();
                setShowLoadingUIState(true);
            } else{
                setInputErrorState("Please enter input field");
            }
    }

    const handleInput = (e)=>{
        setInputErrorState(initialInputErrorState);
        setInputFieldState({...inputFieldState, [e.target.name]:e.target.value  })
    }

    const callLoginAPI = ()=>{
        axios.get(`${process.env.REACT_APP_BASE_URL}/LoginUser?user=${inputFieldState.username}&pass=${inputFieldState.password}`).then(
            (res)=>{
                setShowLoadingUIState(false);
                console.log(res);
                console.log("res.data.result1.value[0].Userlogin" , res.data.result1.value[0].Userlogin, "sdfd");
                
                if(res.data.result1.value[0].Userlogin == "Sucess"){

                    localStorage.setItem("cubix_order_taking_isAuthenticated", true);
                    localStorage.setItem("cubix_order_taking_sales_man", inputFieldState.username);
                    localStorage.setItem("cubix_order_taking_logged_in_person_group", res.data.result1.value[0].accessgrp);
                    localStorage.setItem("cubix_order_taking_array_of_accessgroup", JSON.stringify(res.data.result2.value));

                    
                    navigate('/home');
                }else{
                    setInputErrorState("please enter correct username and password");
                }
            }
        ).catch((err)=>{
            setShowLoadingUIState(false);
            setInputErrorState("Something went wrong , please try again");
        })
    }

    useEffect(()=>{

        console.log("inside Login screen");
        
        // show loading screen
        setLoadingScreenState(true);

        try {
            if(localStorage.getItem("cubix_order_taking_isAuthenticated")){
                let cubix_order_taking_isAuthenticated = JSON.parse(localStorage.getItem("cubix_order_taking_isAuthenticated"));
    
                console.log("cubix isAuth is ", cubix_order_taking_isAuthenticated)
                if(cubix_order_taking_isAuthenticated == true){
                    setLoadingScreenState(false);
                    navigate('/home');
                }else{
                    setLoadingScreenState(false);
                }
            }else{
                console.log("else of cubix_Auth");
                setLoadingScreenState(false);
            }
          }
          catch(err) {
            setLoadingScreenState(false);
            console.log("inside catch of cubix_Auth");
          }

        

    },[]);

    return(
        <div className="LoginPage-root-container">
            
            <div className="LoginPage-layer-1">
                <img src={ic_blue_cube}/>
            </div>
            
            <div className="LoginPage-layer-2 ">
                <img src={ic_cubix_ribbon_logo}/>
                <h2 className="text-center">Order Taking System</h2>
                <div className="LoginPage-inner-card ">
                    <input className="mt-2" placeholder="Username" type="text" name="username" value={inputFieldState.username} onChange={(e)=>handleInput(e)}/>
                    <input className="mt-2" placeholder="Password" type="password" name="password" value={inputFieldState.password} onChange={(e)=>handleInput(e)}/>

                {inputErrorState.length > 0 ? 
                    <div className="text-danger text-center mt-3">
                        <label>{inputErrorState}</label>
                    </div>
                    :
                    null
                }

                    <span>
                        <button className="mt-4" onClick={clickedOnLogin}>Log in</button>
                    </span>
                </div>

                {showLoadingUIState && 
                    <LoadingUI />
                }
            </div>
            
            {loadingScreenState && 
                        <div className="LoginPage-Loading-Layout">
                            <div className="LoginPage-Loading-Layout-child card">
                            <LoadingUI />
                            </div>
                        </div>
            }

        </div>
    )

}

export default LoginPage;